module.exports = __webpack_public_path__ + "img/ozo_nav_icon.633c6185.svg";